import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { sortByProperties } from 'donor-elf-web/lib/array-utils';
import V2TaskModel from 'donor-elf-web/models/v2-task';
import Store from '@ember-data/store';

export interface JournalReportMoreInfo {
  heading: string;
  dateFormatted?: string;
  taskIds?: number;
}

export interface JournalReportMoreInfoComponentArgs {
  info: JournalReportMoreInfo;
  onCloseRequested: () => void;
}

export default class JournalReportMoreInfoComponent extends Component<JournalReportMoreInfoComponentArgs> {
  @service declare store: Store;

  @tracked loading = true;
  @tracked tasks?: V2TaskModel[];

  @action
  templateDidInsert() {
    this.load();
  }

  async load() {
    this.loading = true;
    let tasks = (
      await this.store.query('v2-task', {
        filter: { id: this.args.info.taskIds },
      })
    ).slice();
    if (!this.isDestroyed) {
      this.tasks = sortByProperties(tasks, [
        'completedDate:asc',
        'contactId:asc',
      ]);
      this.loading = false;
    }
  }
}
